export default "<div class=\"{{cssFullClass}}\" role=\"alert\">\n  {{displayMessage}}\n</div>\n"